import React from 'react';
import { Search, ClipboardCheck, Truck, FileCheck } from 'lucide-react';
import { services } from '../data/mockData';

const iconMap = {
  search: Search,
  clipboard: ClipboardCheck,
  truck: Truck,
  filecheck: FileCheck
};

const ServicesSection = () => {
  return (
    <section className="services-section">
      <div className="section-header">
        <div className="section-line red" />
        <h2 className="section-title">NUESTROS SERVICIOS</h2>
        <div className="section-line red" />
      </div>
      <p className="section-subtitle">
        Un servicio integral para que solo tengas que preocuparte de disfrutar de tu Jeep Wrangler
      </p>
      <div className="services-grid">
        {services.map((service) => {
          const IconComponent = iconMap[service.icon];
          return (
            <div key={service.id} className="service-card">
              <div className="service-icon-wrapper">
                <IconComponent size={28} color="#D70000" />
              </div>
              <h3 className="service-card-title">{service.title}</h3>
              <p className="service-card-desc">{service.description}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default ServicesSection;
